import { getCountdownParts, pad2 } from '@/utils/countdown';
import { Ionicons } from '@expo/vector-icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, Text, View } from 'react-native';

export default function RankingCountdown({ remainingMs }: { remainingMs: number }) {
  const { t } = useTranslation();
  const parts = getCountdownParts(remainingMs);

  return (
    <View style={styles.card}>
      <Ionicons name="trophy-outline" size={48} color="#CD7728" />
      <Text style={styles.title} accessibilityRole="header">
        {t('ranking.waitingTitle')}
      </Text>
      <Text style={styles.text}>{t('ranking.waitingText')}</Text>
      <View
        style={styles.timer}
        accessible
        accessibilityRole="timer"
        accessibilityLabel={t('ranking.waitingA11y', {
          days: parts.days,
          hours: pad2(parts.hours),
          minutes: pad2(parts.minutes),
          seconds: pad2(parts.seconds),
        })}
      >
        <TimerBlock value={String(parts.days)} label={t('ranking.countdownDays')} />
        <TimerBlock value={pad2(parts.hours)} label={t('ranking.countdownHours')} />
        <TimerBlock value={pad2(parts.minutes)} label={t('ranking.countdownMinutes')} />
        <TimerBlock value={pad2(parts.seconds)} label={t('ranking.countdownSeconds')} />
      </View>
    </View>
  );
}

function TimerBlock({ value, label }: { value: string; label: string }) {
  return (
    <View style={styles.block}>
      <Text style={styles.value}>{value}</Text>
      <Text style={styles.label}>{label}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    backgroundColor: '#FFF',
    borderRadius: 16,
    padding: 32,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
    marginTop: 8,
  },
  title: {
    fontFamily: 'Inter_700Bold',
    fontSize: 18,
    color: '#000',
    marginTop: 16,
    marginBottom: 8,
    textAlign: 'center',
  },
  text: {
    fontFamily: 'Inter_400Regular',
    fontSize: 14,
    color: '#666',
    textAlign: 'center',
    lineHeight: 20,
    marginBottom: 24,
  },
  timer: {
    flexDirection: 'row',
    gap: 8,
    width: '100%',
  },
  block: {
    flex: 1,
    backgroundColor: '#FBEFE3',
    borderRadius: 12,
    paddingVertical: 12,
    alignItems: 'center',
  },
  value: {
    fontFamily: 'Inter_700Bold',
    fontSize: 22,
    color: '#1C453F',
    fontVariant: ['tabular-nums'],
  },
  label: {
    fontFamily: 'Inter_400Regular',
    fontSize: 11,
    color: '#666',
    marginTop: 2,
  },
});
